import data from "@src/data/data.json";

export const getTopPositionsTableHeadData = (language: LanguageItem): any[] => {
  return [
    {
      id: 1,
      content: data[language].Analytics.TopPositions.Table.Header.Rang,
      sortName: "rang",
    },
    {
      id: 2,
      content: data[language].Analytics.TopPositions.Table.Header.Product,
      sortName: "product",
    },
    {
      id: 3,
      content: data[language].Analytics.TopPositions.Table.Header.Orders,
      sortName: "orders",
    },
    {
      id: 4,
      content: data[language].Analytics.TopPositions.Table.Header.TotalSum,
      sortName: "amount",
    },
  ];
};